module.exports = __webpack_public_path__ + "img/53.414428ce.jpg";